import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { TradeType } from 'store/market/types'
import { TokenSymbol } from 'types'

export const MarketRoutePrefix = {
  [TradeType.Spot]: '/trade',
  [TradeType.Perp]: '/perp',
  [TradeType.None]: '/trade',
}

export function useMarketNavigate() {
  const navigate = useNavigate()

  const navigateToMarket = useCallback(
    (
      tradeType: TradeType,
      baseCurrency: TokenSymbol,
      quoteCurrency: TokenSymbol
    ) => {
      const prefix = MarketRoutePrefix[tradeType]
      const marketPath = `${prefix}/${baseCurrency}/${quoteCurrency}`
      navigate(marketPath)
    },
    [navigate]
  )

  const navigateToSpot = useCallback(
    (baseCurrency: TokenSymbol, quoteCurrency: TokenSymbol) => {
      navigateToMarket(TradeType.Spot, baseCurrency, quoteCurrency)
    },
    [navigateToMarket]
  )
  const navigateToPerp = useCallback(
    (baseCurrency: TokenSymbol, quoteCurrency: TokenSymbol) => {
      navigateToMarket(TradeType.Perp, baseCurrency, quoteCurrency)
    },
    [navigateToMarket]
  )

  return { navigateToMarket, navigateToSpot, navigateToPerp }
}
